export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const session = useVisitorSession()
  const user = useUser()

  if (session.realAdmin) return
  if (!user?.extra?.suspend) return
  if (to.path === '/suspended') return

  const from = to.fullPath || ''
  const query = from && from !== '/suspended' ? { from } : undefined
  return navigateTo({ path: '/suspended', query })
})
